<template>
  <EdroneModal
    v-if="!!details"
    :open="!state.hasTag('closed')"
    :width="720"
    unique-id="1dfbe7c0-0004-43f2-8538-33ef3a05d689"
    @close="handleClose(state.can('CLOSE'))"
  >
    <template #title>
      {{ details.type.charAt(0) + details.type.slice(1).replaceAll("_", " ").toLowerCase() }}
    </template>
    <div
      :class="[
        $options.name,
        'tw:flex flex-column align-center',
        state.hasTag('displayDetails') ? 'tw:justify-start' : 'tw:justify-center',
      ]"
    >
      <template v-if="state.hasTag('fetchingEmail')">
        <EdroneResultState type="loading" unique-id="1c80ba91-7d37-46ef-8e2c-e5beb255f50e">
          <h3 class="tw:body-2">{{ trans._inbox.customer.activity.preview.email.loading }}</h3>
        </EdroneResultState>
      </template>
      <template v-else-if="email && state.hasTag('displayDetails')">
        <div :class="[$options.name + '_info-text', 'tw:pt-4 tw:mb-3']">
          <p class="tw:caption" style="color: #545454">
            {{ trans._inbox.customer.activity.preview.email.sender }}
          </p>
          <p class="tw:m-0">{{ email.sender }}</p>
        </div>
        <hr class="tw:m-0" />
        <div :class="[$options.name + '_info-text', 'tw:pt-3 tw:mb-3']">
          <p class="tw:caption" style="color: #545454">
            {{ trans._inbox.customer.activity.preview.email.subject }}
          </p>
          <p class="tw:m-0">{{ email.subject }}</p>
        </div>
        <hr class="tw:m-0" />
        <div :class="[$options.name + '_email-container', 'tw:mt-6 tw:p-4']">
          <NewsletterHubPreviewEmail v-if="email.html" :html="email.html" />
        </div>
      </template>
      <!--  state.hasTag('errorView') -->
      <template v-else>
        <EdroneResultState type="error" unique-id="184687bb-815a-45ad-a5bc-c105a55bedc7">
          <h3 class="tw:heading-2">{{ trans._inbox.customer.activity.preview.email.error.title }}</h3>
          <p class="tw:body-2 tw:mb-4">{{ trans._inbox.customer.activity.preview.email.error.description }}</p>
          <div>
            <EdroneButton type="outline" unique-id="85667c1c-af2d-49f1-828b-ea29bb72e2be" @click="send('FETCH_EMAIL')">
              {{ trans._inbox.customer.activity.preview.email.error.retry }}
            </EdroneButton>
          </div>
        </EdroneResultState>
      </template>
    </div>
  </EdroneModal>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import EmailPreview from "vue-app/components/Newsletters/components/EmailPreview.vue";
import { useActivityPreview, Email } from "../machines/machineCustomerPreviewActivityPreview";
import { Activity, useCustomerPreviewActor } from "vue-app/pages/machines/machineCustomerPreview";
import EdroneButton from "edrone-components/EdroneButton.vue";
import EdroneModal from "edrone-components/EdroneModal.vue";
import EdroneResultState from "edrone-components/EdroneResultState.vue";

export default defineComponent({
  name: "CustomerPreviewActivityPreviewEmailModal",
  components: {
    EdroneButton,
    EdroneModal,
    EdroneResultState,
    NewsletterHubPreviewEmail: EmailPreview,
  },
  emits: ["close"],
  setup(props, context) {
    const customerPreviewActor = useCustomerPreviewActor();
    const { state, send } = useActivityPreview(customerPreviewActor);

    const email = computed(() => {
      return state.value.context.email;
    }) as unknown as Email | null;

    const details = computed(() => {
      return state.value.context.details;
    }) as unknown as Activity | null;

    const handleClose = (canClose: boolean) => {
      if (!canClose) return;
      context.emit("close");
      send("CLOSE");
    };

    return {
      state,
      send,
      email,
      details,
      handleClose,
    };
  },
});
</script>

<style scoped>
@reference "vue-app/assets/scss/main.css";

.CustomerPreviewActivityPreviewEmailModal {
  height: 500px;
}

.CustomerPreviewActivityPreviewEmailModal_info-text {
  display: grid;
  grid-template-columns: 100px auto;
  align-items: center;
}

.CustomerPreviewActivityPreviewEmailModal_email-container {
  overflow: auto;
  flex-basis: 100%;
  border-radius: 4px;
}

.CustomerPreviewActivityPreviewEmailModal_email-container {
  @apply tw:bg-default-000;
}
</style>
